import { render, staticRenderFns } from "./Connectors.vue?vue&type=template&id=2fd61cde&scoped=true&"
import script from "./Connectors.vue?vue&type=script&lang=js&"
export * from "./Connectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd61cde",
  null
  
)

export default component.exports